import { render } from "./AppIconicIcon.vue?vue&type=template&id=6de5d02b"
import script from "./AppIconicIcon.vue?vue&type=script&lang=js"
export * from "./AppIconicIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../.yarn/__virtual__/vue-loader-virtual-cc52297f69/2/root/.yarn/berry/cache/vue-loader-npm-17.4.2-00674d01e5-10c0.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__